@use '../../../common/mixins/inputs' as *;
@use '../../../common/styles/variables' as *;

:host {
  display: block;
  height: 100%;
  @include default-css-variables;
}

.nylas-booking-form {
  width: 100%;
  padding: 1.5rem;
  box-sizing: border-box;
  height: 450px;
  overflow-y: auto;
  height: 100%;
}

form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.cta {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;

  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 14px;
  box-sizing: border-box;
  border-top: 1px solid var(--nylas-base-200);

  @media #{$mobile} {
    grid-template-columns: 1fr;
  }

  .consent-disclaimer {
    grid-column: 1 / -1;
    width: 100%;
    font-size: 12px;
    line-height: 1.4;
    color: var(--nylas-base-600);
    text-align: center;
    margin-bottom: 0.75rem;
    padding: 0 0.5rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}

.input-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 1rem;

  input::placeholder {
    color: var(--nylas-base-300);
  }

  label,
  input {
    font-family: var(--nylas-font-family);
    font-size: 16px;
  }

  .help-text {
    margin: 0;
    color: var(--nylas-error);
  }
}

.button-wrapper {
  width: 100%;
  align-items: flex-start;
  height: max-content;
  position: relative;
}

.button-content {
  display: flex;
  gap: 4px;
  align-items: center;
}

input[type='text'],
input[type='email'] {
  @include textfield;

  &.guest-email {
    color: var(--nylas-base-900);
    padding-right: 52px; // Infield button width
  }
}

label {
  @include input-label;
}

button-component.remove-guest {
  position: absolute;
  height: 51px;
  right: 0;

  &.error {
    button {
      border-color: var(--nylas-error);
    }
  }

  button {
    height: inherit;
    border-top-left-radius: initial;
    border-bottom-left-radius: initial;
    border: none !important;
    border-left: 1px solid var(--nylas-base-300) !important;

    &:hover,
    &:focus {
      outline: 1px solid var(--nylas-primary) !important;
      color: var(--nylas-primary);
    }
  }
}

button-component.back {
  button {
    --dot-color: var(--nylas-base-800);
  }
}

.guest-email-input {
  position: relative;
  display: flex;
  width: 100%;
}

multi-select-dropdown {
  &::part(msd_dropdown-label) {
    margin-bottom: 4px;
  }

  &::part(msd_dropdown_error) {
    font-size: 16px;
  }

  &::part(msd_dropdown-button) {
    height: 52px;
    border-color: var(--nylas-base-300);
  }

  &::part(msd_dropdown-button--error) {
    border-width: 2px;
    border-color: var(--nylas-error);
  }
}
